import { BASE_URL } from '../../../../../utils/config.base-url'

export const DOCUMENT_ISSUING_DISCIPLINE_PREFIX_URL =
  '/document-issuing-discipline'
export const URL_ENDPOINT_DOCUMENT_ISSUING_DISCIPLINE = `${BASE_URL}/document-issuing-discipline`
